import React, { useEffect } from "react";

import { Box } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

import Input from "../elements/Input";

const CustomField = ({ field, onChange }) => {
  const { getLabel } = useLocalization();

  useEffect(() => {
    console.log({ field });
  }, [field]);

  const handleNameChange = (name) => {
    onChange(field.name, { ...field, name: name });
  };

  const handleValueChange = (value) => {
    onChange(field.name, { ...field, value: value });
  };

  return (
    <Box
      style={styles.mainContainer}
      gap={1}
    >
      <Input
        label={getLabel("name")}
        value={field.name}
        onChange={(newValue) => handleNameChange(newValue)}
      />
      <Input
        label={getLabel("value")}
        value={field.value}
        onChange={(newValue) => handleValueChange(newValue)}
      />
    </Box>
  );
};

const styles = {
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    border: "1px #ccc solid",
    borderRadius: "8px",
    padding: "4px",
    paddingTop: "8px",
  },
};

export default CustomField;
